export default __webpack_public_path__ + "static/media/kids-cleaning.b8cba487.jpeg";